<template>
  <div class="spinner-container" :class="{ 'inline': inline }">
    <div class="spinner" :style="spinnerStyle"></div>
    <span v-if="text" class="spinner-text" :style="textStyle">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    size: {
      type: String,
      default: '20px'
    },
    color: {
      type: String,
      default: '#ffffff'
    },
    text: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: '#ffffff'
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    spinnerStyle() {
      return {
        width: this.size,
        height: this.size,
        borderColor: this.color,
        borderTopColor: 'transparent'
      };
    },
    textStyle() {
      return {
        color: this.textColor
      };
    }
  }
};
</script>

<style scoped>
.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.spinner-container.inline {
  flex-direction: row;
}

.spinner {
  border: 2px solid;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.spinner-text {
  font-size: 0.875rem;
  font-weight: 500;
}
</style>